

import dayjs from "dayjs";
import { JobAction } from "~~/interface/Job";
export const useShiftWork = (jobs: any) => {

    const checkJobsHasAlreadyShift = ()=>{
        const checkJobHasShift = jobs.find((job: any)=> job.action == JobAction.CHANGE_SHIFT)
        if(checkJobHasShift){
            return checkJobHasShift
        }
        return null
    }

    const getCurrentShiftWorkNumber = ()=>{   
        const shiftwork = checkJobsHasAlreadyShift()
        if(shiftwork){
            const allShiftWork = jobs.filter((job: any)=> job.action == JobAction.CHANGE_SHIFT)
            const lastShiftWork = allShiftWork[allShiftWork.length - 1]
            return lastShiftWork?.shift
        }

        

        //When not found shift work return 1 for init shift
        return 1
    }

    const getCurrentShiftWorkFull = ()=>{
        const shiftwork = getCurrentShiftWorkNumber()
        const openShopJob = jobs.find((job: any) => job.action == JobAction.OPEN);
        if(!openShopJob){
            return shiftwork
        }

        const time = dayjs(openShopJob?.timestamp).format("HHmm")

        const shiftTime = time.substring(0, 4)
        const shift = `${shiftwork}:${shiftTime}`
        return shift
    }



    return {
        checkJobsHasAlreadyShift,
        getCurrentShiftWorkNumber,
        getCurrentShiftWorkFull
    }
}
